import { Box, Divider, Spacer } from '@eatclub-apps/ec-component-library';
import { useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReactComponent as CloseMarkSVG } from '../../../../assets/icons/close_mark.svg';
import { IconButton } from '../../../../components/IconButton';
import { Typography } from '../../../../components/Typography';
import { updateBookingAction } from '../../../../data/actions/bookingAction';
import { addMessageAction } from '../../../../data/actions/messagesAction';
import { bookingKeys, bookingPropTypes } from '../../../../data/models/Booking';
import { restaurantPropTypes } from '../../../../data/models/Restaurant';
import { getVouchersWithTotals } from '../../../../utils/bookingHelpers';
import { formatCurrency } from '../../../../utils/helpers';
import VoucherReference from './VoucherReference';

const VoucherReferences = ({
  booking, // The local booking being created/edited
  restaurant,
  updateBooking,
  bookingTotal,
}) => {
  const theme = useTheme();

  const removeVoucher = (voucherNumber) => {
    const newVouchers = booking?.[bookingKeys.voucherReferences].filter(
      (voucher) => voucher?.voucher !== voucherNumber,
    );

    updateBooking(bookingKeys.voucherReferences, newVouchers);
  };

  const vouchersWithTotals = getVouchersWithTotals(booking.voucherReferences, bookingTotal);

  if (!restaurant?.data?.showVoucherField) {
    return <></>;
  }

  return (
    <Spacer direction='vertical' gap={20} style={{ padding: '0 0 12px 0' }}>
      <Spacer direction='vertical' gap={20}>
        <>
          <Divider color={theme.colors.dividerColor} />
          {vouchersWithTotals.map((voucherReference) => (
            <Spacer key={voucherReference.reference} direction='vertical' gap={2}>
              <Spacer style={{ justifyContent: 'space-between' }}>
                <Spacer>
                  <Box>Voucher reference: {voucherReference?.voucher}</Box>
                  <IconButton
                    onClick={() => removeVoucher(voucherReference?.voucher)}
                    style={{
                      height: '24px',
                      width: '24px',
                      color: 'black',
                      padding: '6px',
                    }}
                    variant='outlined'
                  >
                    <CloseMarkSVG />
                  </IconButton>
                </Spacer>
                <Typography
                  style={{
                    fontFamily: theme.baseTypography.numberFontFamily,
                  }}
                >
                  -{formatCurrency(voucherReference?.usedAmount)}
                </Typography>
              </Spacer>
              {voucherReference?.remainingAmount > 0 && (
                <Box style={{ fontSize: '14px', color: theme.colors.smoke }}>
                  {formatCurrency(voucherReference?.remainingAmount)} remaining
                </Box>
              )}
            </Spacer>
          ))}
        </>
      </Spacer>

      <VoucherReference />
    </Spacer>
  );
};

VoucherReferences.propTypes = {
  booking: bookingPropTypes.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  updateBooking: PropTypes.func.isRequired,
  bookingTotal: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  booking: state.booking,
  restaurant: state.restaurant,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addMessage: addMessageAction,
      updateBooking: updateBookingAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(VoucherReferences);
